import React, {useEffect} from 'react';
import { Container, Col, Row } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { apiCommonTrigger } from '../../../Utils/apiServicehelper';
import { Config } from '../../../Utils/Config';


const InvalidAccess = (props) => {
    const navigate = useNavigate();
    const [timeLeft, setTimeLeft] = React.useState(5);
    const search = useLocation().search;
    const token = new URLSearchParams(search).get('session_id');
    const mtoken  = new URLSearchParams(search).get('checkout_session');
 
 useEffect(() => {
     if(timeLeft===0 && props.from !== "dashboard-unauthorised" && props.from !== "subscription-cancel" && props.from !== "market-payment-cancel"){
        localStorage.clear();
        navigate("/");
     }else if(timeLeft===0 && props.from !== "subscription-cancel" && props.from !== "market-payment-cancel"){
        navigate("/my-market");
     }
 
     // exit early when we reach 0
     if (!timeLeft) return;
 
     // save intervalId to clear the interval when the
     // component re-renders
     const intervalId = setInterval(() => { 
       setTimeLeft(timeLeft - 1);
     }, 1000);
 
     // clear interval on re-render to avoid memory leaks
     return () => clearInterval(intervalId);
     // add timeLeft as a dependency to re-rerun the effect
     // when we update it
   }, [timeLeft]);

   useEffect(() => {
    if(props.from === "subscription-cancel" || props.from === "market-payment-cancel"){
      let tokenkey=props.from === "market-payment-cancel"? mtoken : token
      apiCommonTrigger("get",Config.API_URL +"/subscription/cancelcheckout/" , [tokenkey])
        .then((res) => {
          if (res.status === 200) {

            const accessKey = localStorage.getItem("accessKey");
            if (accessKey && accessKey !== "undefined") {
              navigate("/market-search");
            } else {
              localStorage.clear();
              navigate("/");
            }
            
          }
          else{
            handlingCatchError(res, navigate);
          }
        })
        .catch(err => {
          handlingCatchError(err, navigate);
        })
    }
  }, []);
 
 return (
   <React.Fragment>
       <Container className='common-page'>
           <Row>
               <Col className='text-center mt-4 mb-4'>
                {props.from === "subscription-cancel" || props.from === "market-payment-cancel" ?
                <p style={{fontSize: '15px'}}>Please wait while we processing your request...</p>
                : <p style={{fontSize: '15px'}}>{props.from === 'dashboard-unauthorised' ? "You are not authorized to view this market." : "Your session has been expired!"} You will be redirect to {props.from === 'dashboard-unauthorised' ?"matket list" : "home page"} with in <span style={{fontWeight: "600", color:"#015eea", fontSize:"16px"}}>{timeLeft}</span> seconds.</p>}
               </Col>
           </Row>
       </Container>
   </React.Fragment>
  )
 }

export default InvalidAccess;